import React from 'react';
import classNames from 'classnames';
import { translateTag, getAllTags } from 'utils/trail_helpers';
import * as styles from './styles.module.scss';

export type TagCloudProps = {
  trailTags?: {
    whoToBring: unknown[];
    whatToDo: unknown[];
    whatToSeeAndObstacles: unknown[];
  };
};

const TagCloud = ({ trailTags }: TagCloudProps): JSX.Element => {
  const localizedTags = getAllTags();

  if (!trailTags) {
    return null;
  }

  return (
    <section className={classNames(styles.tagCloud, 'tag-cloud')}>
      {Object.values(trailTags)
        .reduce((allTags, tagSubset) => (tagSubset ? [...allTags, ...tagSubset] : allTags), [])
        .map(tag => (
          <span key={tag as string} className={styles.tag}>
            {translateTag(tag, localizedTags)}
          </span>
        ))}
    </section>
  );
};

export default React.memo(TagCloud);
